import { FADE_MS, HOLD_MS } from './constants';

export interface PlaceholderFadeOptions {
    holdMs?: number;
    fadeMs?: number;
}

interface Handlers {
    onShow: (text: string, phraseIndex: number) => void;
    onHide: () => void;
}

export const runPlaceholderFade = (
    phrases: string[],
    { onShow, onHide }: Handlers,
    options: PlaceholderFadeOptions = {}
) => {
    const { holdMs = HOLD_MS, fadeMs = FADE_MS } = options;

    if (!phrases.length) {
        return () => undefined;
    }

    let index = 0;
    let timeout: ReturnType<typeof setTimeout>;

    const hide = () => {
        onHide();
        index += 1;
        timeout = setTimeout(show, fadeMs);
    };

    const show = () => {
        const phraseIndex = index % phrases.length;

        onShow(phrases[phraseIndex], phraseIndex);
        timeout = setTimeout(hide, holdMs);
    };

    show();

    return () => clearTimeout(timeout);
};
